export enum ProviderEnum {
    CMSTHECAO = 'cmsthecao',
    NAP69 = 'nap69',
    WPAY = 'wpay',
    NCCTOPUP = 'ncctopup',
    NAP69_BTKC = 'nap69_btkc',
    ECO = 'eco',
    TRUONGHAI = 'truonghai',
    THNT = 'thnt'
}

export const ProviderName: Record<ProviderEnum, string> = {
    [ProviderEnum.CMSTHECAO]: "CMS Thẻ cào",
    [ProviderEnum.NAP69]: "Nạp 69",
    [ProviderEnum.WPAY]: "Linh San - Wpay",
    [ProviderEnum.NCCTOPUP]: "NCC Topup",
    [ProviderEnum.NAP69_BTKC]: "Nạp 69 BTKC",
    [ProviderEnum.ECO]: "Eco",
    [ProviderEnum.TRUONGHAI]: "Trường Hải",
    [ProviderEnum.THNT]: "TH NT",
};